import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'

function getWalletSummary(cbs?: any, cbe?: any) {
  try {
    fetchHelper.fetch(`${BASE_API_LIVE_SWAP}/wallet/summary`).then(([resp, status]: any) => {
      if (status === 201 || status === 200) {
        if (cbs) cbs(resp.data)
      } else if (cbe) cbe(resp)
    })
  } catch (error) {
    console.error('getWalletSummary', error)
  }

  return null
}

export default getWalletSummary
